<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="440px">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-3"
          >카페24 - 포인트 상품 만들기</v-card-title
        >
        <v-card-text class="pl-5">
          <p class="mb-0">
            판매하실 포인트 상품 판매가를 입력해주세요.
          </p>
          <p class="mb-0">
            고객이 포인트 상품 구매시 지급할 포인트를 입력하시고
          </p>
          <p class="mb-0">
            저장을 클릭하시면 카페24 상품으로 포인트 상품이 생성됩니다.
          </p>
        </v-card-text>

        <div>
          <v-text-field
            outlined
            v-model="price"
            dense
            class="pl-5 pr-5 mb-3"
            hide-details
            placeholder="포인트 상품 판매가 입력"
            @keydown="M.replaceCommaNumber($event, 15, true)"
            @keyup="M.replaceCommaNumber($event, 15, true)"
          ></v-text-field>

          <v-text-field
            outlined
            v-model="points"
            dense
            class="pl-5 pr-5"
            hide-details
            placeholder="판매시 지급 포인트(적립금) 입력"
            @keydown="M.replaceCommaNumber($event, 15, true)"
            @keyup="M.replaceCommaNumber($event, 15, true)"
          ></v-text-field>
        </div>

        <div class="mt-7 pb-5 ">
          <v-btn
            color="black"
            hide-details
            depressed
            class="white--text ml-5"
            @click="dialog = false"
            width="196"
            >닫기</v-btn
          >

          <v-btn
            color="primary"
            hide-details
            class="white--text ml-2 pl-4 pr-4 mr-5"
            depressed
            width="196"
            @click="productSave()"
            >저장</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <ProgressDialog ref="ProgressDialog"></ProgressDialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/filters.js";
import ProgressDialog from "@/components/common/ProgressDialog.vue";
import Common from "@/libs/common.js";

export default {
  data() {
    return {
      M,
      dialog: null,
      price: null,
      points: null,
      product_no: null,
    };
  },
  methods: {
    resetData: function() {
      Object.assign(this.$data, this.$options.data());
    },
    show: function(params = null) {
      this.resetData();

      if (params) {
        // 수정일때 입력
        this.product_no = params.product_no;
        this.price = Common.comma(params.price);
        this.points = Common.comma(params.points);
      }
      this.dialog = true;
    },
    productSave: async function() {
      if (!this.price || this.price <= 0) {
        alert("포인트 상품 판매가 입력해주세요.");
        return false;
      }
      if (!this.points || this.points <= 0) {
        alert("판매시 지급 포인트(적립금) 입력해주세요.");
        return false;
      }
      this.$refs.ProgressDialog.show();
      if (!this.product_no) {
        // 등록
        let createdProduct = await this.createdProduct();
        let setParams = {
          product_no: createdProduct.product_no,
          price: createdProduct.price,
          points: createdProduct.points,
          product_display_tooltip_show: false,
          display_loading: false,
        };

        this.$emit("addProductList", setParams);
      } else {
        //수정
        let setParams = {
          product_no: this.product_no,
          price: Common.onlyNumber(this.price),
          points: Common.onlyNumber(this.points),
          product_display_tooltip_show: false,
          display_loading: false,
        };
        let result = await this.updateProduct();
        if (result != false) {
          this.$emit("updateProductList", setParams);
        }
      }
      this.$refs.ProgressDialog.hide();
      this.dialog = false;
    },
    createdProduct: async function() {
      let setParams = {
        price: Common.onlyNumber(this.price),
        points: Common.onlyNumber(this.points),
      };
      try {
        let result = await M.api(M.entry("/post/mileage/products"), setParams);
        alert("포인트 상품이 생성되었습니다.");
        return result;
      } catch (e) {
        alert("포인트 상품 생성 실패되었습니다.");
        return false;
      }
    },
    updateProduct: async function() {
      let setParams = {
        price: Common.onlyNumber(this.price),
        points: Common.onlyNumber(this.points),
      };
      try {
        let result = await M.api(
          M.entry("/put/mileage/products", this.product_no),
          setParams
        );
        alert("포인트 상품이 수정되었습니다.");
        return result;
      } catch (e) {
        alert("포인트 상품 수정 실패되었습니다.");
        return false;
      }
    },
  },
  filters: Filters,
  components: {
    ProgressDialog,
  },
};
</script>
